<template>
  <StepTemplate :activeStepNr="this.activeStepNr"
                :myStepNr="this.myStepNr"
                :value="value"

  >
    <template slot="slide-form">

      <form data-vv-scope="xxx" @click.alt="testFillForm()">
        <!--============================================================================================================-->
        <!--
        <v-layout row>
            <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
        </v-layout>
        -->
        <!--============================================================================================================ -->
        <v-layout row class="section_header">
          <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Gebäude-Daten</h6></v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <v-flex xs12 style=" font-size: 0.9em;">
            <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Tragen Sie hier die Straße des zu versichernden Gebäudes ein.
          </Rechner-hint-col>

          <v-flex xs7>
            <Rechner-field-col :fielddef="fieldDefs.woge_lage_strasse" v-model="value.fieldValues" ref="xxxxxx"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs3>
            <Rechner-field-col :fielddef="fieldDefs.woge_lage_strasse_nr" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Tragen Sie hier die Postleitzahl und den Ort des zu versichernden Gebäudes ein.
            <br>
            <br>Diese Daten werden benötigt, da jeder Postleitzahl eine sogenannte Tarifzone zugeordnet ist.
          </Rechner-hint-col>
          <v-flex xs3>
            <Rechner-field-col :fielddef="fieldDefs.woge_lage_plz" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs7>
            <Rechner-field-col :fielddef="fieldDefs.woge_lage_ort" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Wählen Sie hier die <b>Gebäudeart</b> Ihres Wohnhauses aus:
            <div style="border-top:1px solid #ccc">
              <b><i>Einfamilienhaus</i></b>:
              freistehendes Gebäude mit einzelnem Grundstück, ohne ein an die Hauswand angrenzendes Nachbargebäude.
            </div>
            <div style="border-top:1px solid #ccc">
              <b><i>Zweifamilienhaus</i></b>:
              ein Gebäude mit zwei Wohneinheiten und einem Grundstück
            </div>
            <div style="border-top:1px solid #ccc">
              <b><i>Doppelhaushälfte</i></b>:
              zwei aneinander anschließende Gebäude mit jeweils separatem Grundstück bzw. Grundstücksanteil
            </div>
            <div style="border-top:1px solid #ccc">
              <b><i>Reihenhaus</i></b>:
              mehrere aneinander anschließende Gebäude mit jeweils separatem - vergleichsweise kleinem- Grundstück bzw. Grundstücksanteil
              <br>
              <br>
            </div>
            <div style="border-top:2px solid #999">
              <b>Baujahr</b>:
              <br>Geben Sie hier das Jahr an, in dem das Gebäude erstmals bezugsfertig war.
            </div>

          </Rechner-hint-col>
          <v-flex xs5>
            <Rechner-field-col :fielddef="fieldDefs.woge_typ_art" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs5>
            <Rechner-field-col :fielddef="fieldDefs.woge_baujahr" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            <div style="">
              <b>Geschossanzahl:</b>
              Als Geschosse gelten alle zu Wohnzwecken ausgebaute Geschosse über dem Erdgeschoss.
            </div>
            <div style="border-top:2px solid #999">
              <b>Quadratmeter:</b> Die Wohnfläche ist für die Berechnung der Versicherungssumme notwendig.
              <br>Die Wohnfläche ist die Grundfläche aller Räume, einschließlich Hobbyräume, Wintergärten und Arbeitszimmer.
              <br>Nicht zur Wohnfläche zählen Balkone und Terrassen.
            </div>
          </Rechner-hint-col>
          <v-flex xs5>
            <Rechner-field-col :fielddef="fieldDefs.woge_geschosse" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs5>
            <Rechner-field-col :fielddef="fieldDefs.woge_qm" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>

        <v-layout row>
          <Rechner-hint-col>
            <div style="">
              <b>Keller:</b> Eine Unterkellerung hat Einfluss auf die Berechnung.
            </div>
            <div style="border-top:2px solid #999">
              <b>Wohnfläche Keller:</b> Die bewohnbare Fläche im Keller ist separat anzugeben.
              <br>Hierzu zählen z.B. Hobbyräume, ausgeschlossen sind jedoch Nutzflächen für Waschküchen, Heizungs- oder Vorratsräume.
            </div>
          </Rechner-hint-col>
          <v-flex xs5>
            <Rechner-field-col :fielddef="fieldDefs.woge_jn_keller" v-model="value.fieldValues" :$v="$v"
                               class="radio_text_row"></Rechner-field-col>
          </v-flex>
          <v-flex xs5>
            <Rechner-field-col :fielddef="fieldDefs.woge_keller_qm_bewohnt" v-model="value.fieldValues"
                               :disabled="value.fieldValues.woge_jn_keller == '0'" :$v="$v"
                               class="radio_text_row"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>

        <v-layout row>
          <Rechner-hint-col>
            Die Anzahl der zu versichernden Garagen/Carports hat Auswirkung auf die Versicherungssumme.
            <br>Hier werden pauschal 700,00 Mark / Wert 1914 pro Stellplatz berechnet.
          </Rechner-hint-col>
          <v-flex xs5>
            <Rechner-field-col :fielddef="fieldDefs.woge_anzahl_carports" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
          <v-flex xs5>
            <Rechner-field-col :fielddef="fieldDefs.woge_anzahl_garagen" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Die Dachkonstruktion ist für die Bestimmung der Bauartklasse notwendig und hat Einfluss auf die Beitragsermittlung.
            <br>
            <div style="border-top:1px solid #ccc">
              Als <b><i>ausgebautes Dach</i></b>
              wird der Raum bezeichnet, der zum vollwertigen Wohnraum ausgebaut wurde.
            </div>
            <div style="border-top:1px solid #ccc">
              <b><i>Harte Dachung</i></b>:
              Ziegel, Schiefer, Betonplatten, Metall Asbestzement oder gesandete Dachpapp
            </div>
            <div style="border-top:1px solid #ccc">
              <b><i>Weiche Dachung</i></b>:
              brennbare Materialien, wie Holz, Schilf, Ried oder Stroh
            </div>


          </Rechner-hint-col>
          <v-flex xxx class="xs10">
            <Rechner-field-col :fielddef="fieldDefs.woge_typ_dach" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>

        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Die Art der Konstruktion der Bauweise des Gebäudes. Dieser hat Einfluss auf die Beitragsermittlung.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_typ_klasse" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>


        <!--============================================================================================================-->
        <!--============================================================================================================-->
        <!--============================================================================================================-->
        <v-layout row>
          <Rechner-hint-col>
            xxx
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_wert1914_direkt_oder_berechnet" v-model="value.fieldValues"
                               :$v="$v"
                               direction="row"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!--============================================================================================================-->
        <transition name="slide">
          <div v-show="value.fieldValues.woge_wert1914_direkt_oder_berechnet=='direkt'">
            <v-layout row>
              <Rechner-hint-col>
                xxxx
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col :fielddef="fieldDefs.woge_wert1914_direktAngabe" v-model="value.fieldValues"
                                   :$v="$v"></Rechner-field-col>
              </v-flex>
            </v-layout>

          </div>
        </transition>
        <!--============================================================================================================-->
        <transition name="slide">
          <div v-show="value.fieldValues.woge_wert1914_direkt_oder_berechnet=='berechnet'">


            <!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
            <v-layout row class="section_header">
              <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Bauausführung</h6></v-flex>
            </v-layout>
            <!--- 1 --------------------------------------------------------------------------------------------------------->
            <v-layout row>
              <Rechner-hint-col>
                <div style="text-align:left;">
                  xxx
                </div>
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col class=""
                                   :fielddef="fieldDefs.woge_jn_BauAusf_dach"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!--- 2 --------------------------------------------------------------------------------------------------------->
            <v-layout row>
              <Rechner-hint-col>
                <div style="text-align:left;">
                  xxx
                </div>
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col class=""
                                   :fielddef="fieldDefs.woge_jn_BauAusf_aussenwand"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
            <v-layout row class="section_header">
              <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Innenausbau</h6></v-flex>
            </v-layout>
            <!--- 3 --------------------------------------------------------------------------------------------------------->
            <v-layout row>
              <Rechner-hint-col>
                <div style="text-align:left;">
                  xxx
                </div>
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col class=""
                                   :fielddef="fieldDefs.woge_jn_BauAusf_decken"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!--- 4 --------------------------------------------------------------------------------------------------------->
            <v-layout row>
              <Rechner-hint-col>
                <div style="text-align:left;">
                  xxx
                </div>
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col class=""
                                   :fielddef="fieldDefs.woge_jn_BauAusf_fussboden"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!--- 5 --------------------------------------------------------------------------------------------------------->
            <v-layout row>
              <Rechner-hint-col>
                <div style="text-align:left;">
                  xxx
                </div>
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col class=""
                                   :fielddef="fieldDefs.woge_jn_BauAusf_fenster"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!--- 6 --------------------------------------------------------------------------------------------------------->
            <v-layout row>
              <Rechner-hint-col>
                <div style="text-align:left;">
                  xxx
                </div>
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col class=""
                                   :fielddef="fieldDefs.woge_jn_BauAusf_tueren"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
            <v-layout row class="section_header">
              <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Installation</h6></v-flex>
            </v-layout>
            <!--- 7 --------------------------------------------------------------------------------------------------------->
            <v-layout row>
              <Rechner-hint-col>
                <div style="text-align:left;">
                  xxx
                </div>
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col class=""
                                   :fielddef="fieldDefs.woge_jn_BauAusf_sanitaer"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!--- 8 --------------------------------------------------------------------------------------------------------->
            <v-layout row>
              <Rechner-hint-col>
                <div style="text-align:left;">
                  xxx
                </div>
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col class=""
                                   :fielddef="fieldDefs.woge_jn_BauAusf_heizung"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!--- 9 --------------------------------------------------------------------------------------------------------->


            <!--============================================================================================================-->
            <v-layout row class="section_header">
              <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Ergebnis: 1914-Wert</h6></v-flex>
            </v-layout>
            <!------------------------------------------------------------------------------------------------------------>
            <!--
            <v-layout row>
                <Rechner-hint-col>
                    drvfhndgfb bhxcvvdasf <br>
                    ggv gf,kl. jzghn mhk bdfg vdfgf dfg v dgdf gdsg<br>
                    dfdsfds ds dgew qwewfsd fsf<br>
                </Rechner-hint-col>
                <v-flex xs10>
                    <Rechner-field-col :fielddef="fieldDefs.woge_typ_bauart1914" v-model="value.fieldValues" :$v="$v" :disabled="true"></Rechner-field-col>
                </v-flex>
            </v-layout>
            -->
            <!------------------------------------------------------------------------------------------------------------>
            <!--
            <v-layout row>
                <Rechner-hint-col>
                    drvfhndgfb bhxcvvdasf <br>
                    ggv gf,kl. jzghn mhk bdfg vdfgf dfg v dgdf gdsg<br>
                    dfdsfds ds dgew qwewfsd fsf<br>
                </Rechner-hint-col>
                <v-flex xs10>
                    <Rechner-field-col :fielddef="fieldDefs.woge_wert1914" v-model="value.fieldValues" :$v="$v" :disabled="true"></Rechner-field-col>
                </v-flex>
            </v-layout>
            -->
            <!------------------------------------------------------------------------------------------------------------>
            <v-layout row>
              <Rechner-hint-col>
                Aufgrund Ihrer getätigten Angaben wurde diese Versicherungssumme 1914 ermittelt.
              </Rechner-hint-col>
              <v-flex xs10>
                <div style="font-size:1.2rem; text-align:left;">
                  <br>
                  Auf Grund Ihrer Angaben ergeben sich folgende Werte:
                  <br>
                  <br><span class="labelCol">&nbsp; Gebäudetyp: </span><span class="valCol"> {{ value.fieldValues.woge_qm * Wert1914_Bauart }}       Mark</span> <span
                    class="calcCol1"> ({{ value.fieldValues.woge_qm }}m² x </span>
                  <span class="calcCol2"> {{ Wert1914_Bauart }} Mark)</span>
                  <br><span class="labelCol">+Bauausführung:    </span><span class="valCol"> {{ value.fieldValues.woge_qm * Wert1914_Ausst_aussen }} Mark</span> <span
                    class="calcCol1"> ({{ value.fieldValues.woge_qm }}m² x </span>
                  <span class="calcCol2"> {{ Wert1914_Ausst_aussen }} Mark)</span>
                  <br><span class="labelCol">+Innenausbau:      </span><span class="valCol"> {{ value.fieldValues.woge_qm * Wert1914_Ausst_innen }}  Mark</span> <span
                    class="calcCol1"> ({{ value.fieldValues.woge_qm }}m² x </span>
                  <span class="calcCol2"> {{ Wert1914_Ausst_innen }} Mark)</span>
                  <br><span class="labelCol">+Installationen:   </span><span class="valCol"> {{ value.fieldValues.woge_qm * Wert1914_Ausst_inst }}   Mark</span> <span
                    class="calcCol1"> ({{ value.fieldValues.woge_qm }}m² x </span>
                  <span class="calcCol2"> {{ Wert1914_Ausst_inst }} Mark)</span>
                  <br><span class="labelCol">+Wohnfläche Keller:</span><span class="valCol"> {{ value.fieldValues.woge_keller_qm_bewohnt * 15 }}     Mark</span> <span
                    class="calcCol1"> ({{ value.fieldValues.woge_keller_qm_bewohnt }}m² x </span>
                  <span class="calcCol2"> 15 Mark)</span>
                  <br><span class="labelCol">+Garage/Carport:   </span><span class="valCol"> {{ Wert1914_GarageCarport }}                          Mark</span> <span
                    class="calcCol1"> ({{ Wert1914_GarageCarport_Anzahl }} x </span>
                  <span class="calcCol2"> 700 Mark)</span>
                  <br>
                  <br>Dies ergibt einen 1914-Wert von:&nbsp;&nbsp;
                  <b style="font-size:1.25em"> {{ value.fieldValues.woge_wert1914 }} Mark &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</b>

                  <br>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </transition>
        <!--============================================================================================================-->
      </form>

    </template>
  </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
import slideMixin from '../stepMixin'
import _ from 'lodash'
//import {mapState} from 'vuex'

export default {
  //========================================================================================================
  name: 'Step_wohngebaude_I',
  label: 'Gebäudedaten',
  label2: 'Gebäude<br>Daten',
  fieldKeys: [
    'woge_lage_strasse',
    'woge_lage_strasse_nr',
    'woge_lage_plz',
    'woge_lage_ort',
    'woge_geschosse',
    'woge_typ_bauart1914',
    'woge_typ_art',
    'woge_typ_dach',
    'woge_typ_klasse',
    'woge_wert1914_direkt_oder_berechnet',
    'woge_wert1914_direktAngabe',
    'woge_qm',
    'woge_jn_keller',
    'woge_keller_qm_bewohnt',
    'woge_baujahr',
    'woge_wert1914',
    'woge_anzahl_garagen',
    'woge_anzahl_carports',

    'woge_jn_BauAusf_dach',        // 1
    'woge_jn_BauAusf_aussenwand',  // 2
    'woge_jn_BauAusf_decken',      // 3
    'woge_jn_BauAusf_fussboden',   // 4
    'woge_jn_BauAusf_fenster',     // 5
    'woge_jn_BauAusf_tueren',      // 6
    'woge_jn_BauAusf_sanitaer',    // 7
    'woge_jn_BauAusf_heizung',     // 8
    //   'woge_jn_BauAusf_photovoltaik',// 9


  ],
  //========================================================================================================
  data: function () {
    //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
    //an dieser Stelle können diese Werte überschrieben werden.
    // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
    var fieldDefs_OVERRIDE = {}

    return {
      Wert1914_Bauart: 0,
      Wert1914_Ausstattung: 0,
      Wert1914_Ausst_aussen: 0,
      Wert1914_Ausst_innen: 0,
      Wert1914_Ausst_inst: 0,
      Wert1914_GarageCarport: 0,
      Wert1914_GarageCarport_Anzahl: 0,
      fieldDefs: fieldDefs_OVERRIDE,

    }
  }, //========================================================================================================
  mixins: [slideMixin],
  //===========================================================================================================
  methods: {
    test: function () {
      console.log("### LÜPPT #######", this.$refs.xxxxxx.$refs.input)
      console.log(this)
      this.$refs.xxxxxx.$refs.input.focus();
    },
  }, //========================================================================================================
  watch: {

    value: {
      handler: function (newVal, oldVal) {
        console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
        console.log("WATCHER fieldValues in ", this.$options.label)
        var fV = this.value.fieldValues
        var fVold = this.frmValuesOld
        var fD = this.fieldDefs
        var earlyExit = true;
        for (var key in fV) {
          if (fV[key] !== fVold[key]) {
            earlyExit = false
            console.log("changed ", key, fVold[key], '->', fV[key])
            this.update_Ort_by_PLZ(key)
          }
        }
        if (earlyExit === true) {
          console.log("NO changes -> early EXIT")
          return;
        }

        /*------------------------------------------------------------------------------------*/
        if (fV.woge_wert1914_direkt_oder_berechnet == 'berechnet' && fV.woge_wert1914_direkt_oder_berechnet !== fVold.woge_wert1914_direkt_oder_berechnet) {
          this.value.fieldValues.woge_wert1914_direktAngabe = 0;
          this.value.fieldValues.woge_jn_BauAusf_dach = null;
          this.value.fieldValues.woge_jn_BauAusf_aussenwand = null;
          this.value.fieldValues.woge_jn_BauAusf_decken = null;
          this.value.fieldValues.woge_jn_BauAusf_fussboden = null;
          this.value.fieldValues.woge_jn_BauAusf_fenster = null;
          this.value.fieldValues.woge_jn_BauAusf_tueren = null;
          this.value.fieldValues.woge_jn_BauAusf_sanitaer = null;
          this.value.fieldValues.woge_jn_BauAusf_heizung = null;
        }
        if (fV.woge_wert1914_direkt_oder_berechnet == 'direkt' && fV.woge_wert1914_direkt_oder_berechnet !== fVold.woge_wert1914_direkt_oder_berechnet) {
          this.value.fieldValues.woge_wert1914_direktAngabe = null;

          this.value.fieldValues.woge_jn_BauAusf_dach = 1; //muss 1 sein, damit Validate von Dach-Art klaptt, auch wenn "!914 liegt vor" gewählt wurde
          this.value.fieldValues.woge_jn_BauAusf_aussenwand = 0;
          this.value.fieldValues.woge_jn_BauAusf_decken = 0;
          this.value.fieldValues.woge_jn_BauAusf_fussboden = 0;
          this.value.fieldValues.woge_jn_BauAusf_fenster = 0;
          this.value.fieldValues.woge_jn_BauAusf_tueren = 0;
          this.value.fieldValues.woge_jn_BauAusf_sanitaer = 0;
          this.value.fieldValues.woge_jn_BauAusf_heizung = 0;


        }
        /*------------------------------------------------------------------------------------*/
        if (parseInt(fV.woge_jn_keller, 10) === 0 && fVold.woge_jn_keller !== fV.woge_jn_keller) {
          this.value.fieldValues.woge_keller_qm_bewohnt = 0;
          console.log(fV.woge_jn_keller, ' -> diasble Keller qm ', this.value.fieldValues.woge_keller_qm_bewohnt)
          console.log("WATCHER: update  woge_keller_qm_bewohnt")
        }
        /*------------------------------------------------------------------------------------*/
        // Bauart aus Keller, Geschosse, Dach errechnen:
        var keller_value = fV.woge_jn_keller ? fV.woge_jn_keller : ''
        var geschosse_value = fV.woge_geschosse ? parseInt(fV.woge_geschosse, 10) : ''
        var dach_value = fV.woge_typ_dach ? fV.woge_typ_dach : ''

        //umwandeln der Weich-Dach-Kennung in Normal-Dach-Kennung (WDGna -> DGna /   WDGa -> DGa ),
        //da 1914-Wert der Dächer gleich sind (evtl. weiter unten 4Mark Aufschlag bei 'woge_jn_BauAusf_dach')
        dach_value = dach_value.replace("W", "")

        console.log("** ** ** **", fV)
        console.log(keller_value, geschosse_value, dach_value)

        var Bauart_erechnet = "K:" + keller_value + ",G:" + geschosse_value + ",D:" + dach_value
        if (Bauart_erechnet !== fVold.woge_typ_bauart1914) {
          console.log("WATCHER: update  woge_typ_bauart1914")
          fV.woge_typ_bauart1914 = Bauart_erechnet
        }
        //------------------------------------------------------------------------------------------------

        // Kategorie 1:  Bauart:
        var Bauart_Option = _.find(fD.woge_typ_bauart1914.selectOptions, {value: fV.woge_typ_bauart1914})
        var Wert1914_Bauart = Bauart_Option ? parseInt(Bauart_Option.value_1914, 10) : 0
        console.log("Wert1914_Bauart", Wert1914_Bauart, " aus BauArt:", Bauart_Option)
        //.......................................................................................
        // Kategorie 2: Ausstatung-Niveau:

        /*
        //alt:
        var ausstattung_Option_aussen = _.find(fD.woge_typ_ausstattung_aussen.selectOptions, {value: fV.woge_typ_ausstattung_aussen})
        var Wert1914_Ausst_aussen = ausstattung_Option_aussen ? parseInt(ausstattung_Option_aussen.value_1914, 10) : 0

        var ausstattung_Option_innen = _.find(fD.woge_typ_ausstattung_innen.selectOptions, {value: fV.woge_typ_ausstattung_innen})
        var Wert1914_Ausst_innen = ausstattung_Option_innen ? parseInt(ausstattung_Option_innen.value_1914, 10) : 0

        var ausstattung_Option_inst = _.find(fD.woge_typ_ausstattung_inst.selectOptions, {value: fV.woge_typ_ausstattung_inst})
        var Wert1914_Ausst_inst = ausstattung_Option_inst ? parseInt(ausstattung_Option_inst.value_1914, 10) : 0

*/

        var wert_BauAusf_dach = parseInt(fV.woge_jn_BauAusf_dach, 10) === 1 ? fD.woge_jn_BauAusf_dach.extra.w1914 : 0
        var wert_BauAusf_aussenwand = parseInt(fV.woge_jn_BauAusf_aussenwand, 10) === 1 ? fD.woge_jn_BauAusf_aussenwand.extra.w1914 : 0
        var wert_BauAusf_decken = parseInt(fV.woge_jn_BauAusf_decken, 10) === 1 ? fD.woge_jn_BauAusf_decken.extra.w1914 : 0
        var wert_BauAusf_fussboden = parseInt(fV.woge_jn_BauAusf_fussboden, 10) === 1 ? fD.woge_jn_BauAusf_fussboden.extra.w1914 : 0
        var wert_BauAusf_fenster = parseInt(fV.woge_jn_BauAusf_fenster, 10) === 1 ? fD.woge_jn_BauAusf_fenster.extra.w1914 : 0
        var wert_BauAusf_tueren = parseInt(fV.woge_jn_BauAusf_tueren, 10) === 1 ? fD.woge_jn_BauAusf_tueren.extra.w1914 : 0
        var wert_BauAusf_sanitaer = parseInt(fV.woge_jn_BauAusf_sanitaer, 10) === 1 ? fD.woge_jn_BauAusf_sanitaer.extra.w1914 : 0
        var wert_BauAusf_heizung = parseInt(fV.woge_jn_BauAusf_heizung, 10) === 1 ? fD.woge_jn_BauAusf_heizung.extra.w1914 : 0

        var Wert1914_Ausst_aussen = wert_BauAusf_dach + wert_BauAusf_aussenwand
        var Wert1914_Ausst_innen = wert_BauAusf_decken + wert_BauAusf_fussboden + wert_BauAusf_fenster + wert_BauAusf_tueren
        var Wert1914_Ausst_inst = wert_BauAusf_sanitaer + wert_BauAusf_heizung
        var Wert1914_Ausstattung = Wert1914_Ausst_aussen + Wert1914_Ausst_innen + Wert1914_Ausst_inst
        console.log("Wert1914_Ausstattung", Wert1914_Ausstattung)


        //.......................................................................................
        // Wohnfläche:
        var qm = fV.woge_qm ? parseInt(this.$numeral(fV.woge_qm).value(), 10) : 0
        var qmKeller = fV.woge_keller_qm_bewohnt ? parseInt(this.$numeral(fV.woge_keller_qm_bewohnt).value(), 10) : 0
        console.log("qm + qmKeller", qm, qmKeller)
        //.......................................................................................
        // Garage Carport:
        var Wert1914_GarageCarport = 0
        var garagen = fV.woge_anzahl_garagen ? parseInt(fV.woge_anzahl_garagen, 10) : 0
        var carports = fV.woge_anzahl_carports ? parseInt(fV.woge_anzahl_carports, 10) : 0
        this.Wert1914_GarageCarport_Anzahl = garagen + carports
        if (this.Wert1914_GarageCarport_Anzahl === 1) {
          Wert1914_GarageCarport = 700
        }
        if (this.Wert1914_GarageCarport_Anzahl === 2) {
          Wert1914_GarageCarport = 1400
        }
        if (this.Wert1914_GarageCarport_Anzahl > 2) {
          Wert1914_GarageCarport = 2100
        }
        console.log("Wert1914_GarageCarport", Wert1914_GarageCarport, this.Wert1914_GarageCarport_Anzahl)
        //.......................................................................................
        var calculated1914 = (Wert1914_Bauart + Wert1914_Ausstattung) * qm + qmKeller * 15 + Wert1914_GarageCarport
        var current1914 = fV.woge_wert1914
        //var old1914 = frmValuesOld.woge_wert1914

        if (calculated1914 !== current1914) {
          this.Wert1914_Bauart = Wert1914_Bauart
          this.Wert1914_Ausstattung = Wert1914_Ausstattung
          this.Wert1914_Ausst_aussen = Wert1914_Ausst_aussen
          this.Wert1914_Ausst_innen = Wert1914_Ausst_innen
          this.Wert1914_Ausst_inst = Wert1914_Ausst_inst
          this.Wert1914_GarageCarport = Wert1914_GarageCarport

          fV.woge_wert1914 = calculated1914
          console.log("WATCHER: update woge_wert1914 (old,new)", calculated1914, current1914)
        } else {

        }

        //----------------------------------------------------------------------------

        this.frmValuesOld = _.assign({}, fV)
        //for (var index in fV) {
        // this.frmValuesOld[index] = fV[index]
        //  console.log("setOld(o,c,old)", index, this.value.fieldValues[key], fV[key], this.frmValuesOld[key])
        // }

      },
      deep: true,

    },
  }, //========================================================================================================
  components: {/* programmatically setted by step-mixin*/},
  //===========================================================================================================
  props: [/* programmatically setted by step-mixin*/],
  //===========================================================================================================
  // HOOKS:
  /* programmatically setted by step-mixin*/
  //===========================================================================================================
}
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>
span.labelCol {
  display: inline-block;
  min-width: 160px;

}

span.valCol {
  display: inline-block;
  min-width: 100px;
  text-align: right;

}

span.calcCol1 {
  font-style: italic;
  opacity: 0.6;
  display: inline-block;
  min-width: 120px;
  text-align: right;

}

span.calcCol2 {
  font-style: italic;
  opacity: 0.6;
  display: inline-block;
  min-width: 90px;
  text-align: right;

}

/* =======================================*/
.slide-enter-active {
  -moz-transition-duration: 1.5s;
  -webkit-transition-duration: 1.5s;
  -o-transition-duration: 1.5s;
  transition-duration: 1.5s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 1.5s;
  -webkit-transition-duration: 1.5s;
  -o-transition-duration: 1.5s;
  transition-duration: 1.5s;


}

.slide-enter-to, .slide-leave {
  max-height: 400px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

</style>
